import { Action, createReducer, on } from '@ngrx/store';
import {
    loadAutoAssignSettingsFailure,
    loadAutoAssignSettingsSuccess,
    loadCredentialingPermissionsFailure,
    loadCredentialingPermissionsSuccess,
    loadNotificationCategoryFailure,
    loadNotificationCategorySuccess,
    updateCredentialingSpecialistFromCandidatesGridSuccess,
    updateCredentialingSpecialistFromCandidatesGridFailure
} from 'src/app/credentialing/+store/actions/credentialing.actions';
import {
    bulkUnassignCredentialingSpecialistFromRecruitingCandidatesGridSuccess,
    bulkUpdateCredentialingSpecialistFromRecruitingCandidatesGridSuccess,
    bulkUnassignCredentialingSpecialistFromRecruitingCandidatesGrid,
    bulkUpdateCredentialingSpecialistFromRecruitingCandidatesGrid
} from 'src/app/compliance/store/actions/compliance.actions';
import { CredentialingState } from 'src/app/credentialing/+store/state/credentialing.state';

export const credentialingFeatureKey = 'credentialing';

const initialState: CredentialingState = {
    permissions: undefined,
    autoAssignTypes: [],
    notificationCategory: undefined,
    router: undefined,
    error: undefined,
    autoAssign: undefined,
    updatedGridItem: undefined,
    reloadRecruitingCandidatesGrid: false
};

const reducer = createReducer(
    initialState,

    on(
        bulkUnassignCredentialingSpecialistFromRecruitingCandidatesGridSuccess,
        bulkUpdateCredentialingSpecialistFromRecruitingCandidatesGridSuccess,
        (state, action) => ({
            ...state,
            reloadRecruitingCandidatesGrid: true
        })
    ),

    on(
        bulkUnassignCredentialingSpecialistFromRecruitingCandidatesGrid,
        bulkUpdateCredentialingSpecialistFromRecruitingCandidatesGrid,
        (state, action) => ({
            ...state,
            reloadRecruitingCandidatesGrid: false
        })
    ),

    on(updateCredentialingSpecialistFromCandidatesGridSuccess, (state, action) => ({
        ...state,
        updatedGridItem: action.updatedGridItem['item1']
    })),
    on(updateCredentialingSpecialistFromCandidatesGridFailure, (state, action) => ({
        ...state,
        error: action.error
    })),
    on(loadCredentialingPermissionsSuccess, (state, action) => ({
        ...state,
        permissions: action.permissions,
        error: undefined
    })),

    on(loadCredentialingPermissionsFailure, (state, action) => ({
        ...state,
        permissions: undefined,
        error: action.error
    })),

    on(loadAutoAssignSettingsSuccess, (state, action) => ({
        ...state,
        autoAssignTypes: action.settings,
        error: undefined
    })),

    on(loadAutoAssignSettingsFailure, (state, action) => ({
        ...state,
        autoAssignTypes: [],
        error: action.error
    })),

    on(loadNotificationCategorySuccess, (state, action) => ({
        ...state,
        notificationCategory: action.notification,
        error: undefined
    })),

    on(loadNotificationCategoryFailure, (state, action) => ({
        ...state,
        notificationCategory: undefined,
        error: action.error
    }))
);

export function credentialingReducer(state: CredentialingState | undefined, action: Action) {
    return reducer(state, action);
}
